
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export const optionConfig = {
    public:['picture','video','audio','other'],

};
